import { Component, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { ACCURACY_COMPARISON } from '../../components/rid-feedback-comparison-toast/reading-feedback-comparisons';
import { RidFeedbackComparisonToast } from '../../components/rid-feedback-comparison-toast/rid-feedback-comparison-toast';
import { RidHorizontalPages } from '../../components/rid-horizontal-pages/rid-horizontal-pages';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidModalBackground } from '../../components/rid-modal-background/rid-modal-background';
import { RidRatingModal } from '../../components/rid-rating-modal/rid-rating-modal';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidWordMatrix } from '../../components/rid-word-matrix/rid-word-matrix';
import { DiceService } from '../../services/dice-service.service';

@Component({
  selector: 'rid-reading-matrix-no-time',
  imports: [
    RidTopBar,
    RidMechanicBackground,
    RidRatingModal,
    RidFeedbackComparisonToast,
    RidMechanicTitle,
    RidMechanicContent,
    RidMechanicWrapper,
    RidBottomButton,
    RidModalBackground,
    RidHorizontalPages,
    RidWordMatrix,
  ],
  templateUrl: './rid-reading-matrix-no-time.html',
  host: {
    class: 'block',
  },
})
export class RidReadingMatrixNoTime implements OnInit, OnDestroy {
  protected readonly accuracyComparison = ACCURACY_COMPARISON;
  private readonly $diceService = inject(DiceService);

  matrices = input.required<string[][][]>();
  previousAccuracy = input<number>();

  index = signal(0);
  state = signal<{ type: 'READING' } | { type: 'RATING' } | { type: 'ACCURACY_FEEDBACK'; accuracy: number } | { type: 'VIEWING' }>({
    type: 'READING',
  });

  finished = output<void>();

  ngOnInit(): void {
    this.$diceService.isNumericDiceAvailable.set(true);
  }

  ngOnDestroy(): void {
    this.$diceService.isNumericDiceAvailable.set(false);
  }

  finishReading() {
    this.state.set({ type: 'RATING' });
  }

  rate(accuracy: number) {
    this.state.set({ type: 'ACCURACY_FEEDBACK', accuracy });
  }

  view() {
    this.state.set({ type: 'VIEWING' });
  }

  finish() {
    this.finished.emit();
  }
}
